function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.5 31C9.833 44 40 70.5 86 72.5c57.5 2.5 61.972-3.788 65.5-9.5C162 46 122 32 125 52.5c3.809 26.029 40 33 69 28 23.2-4 74.667-26 97.5-36.5",
  stroke: "#444",
  strokeDasharray: "5 3"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M334.439 13.317a.84.84 0 00-.823-.36l-40.213 6.13a.84.84 0 00-.408 1.48l8.577 7.073-.203 11.831a.84.84 0 00.631.829.828.828 0 00.63-.098l.006.01 8.285-4.862 6.692 5.52a.84.84 0 001.26-.222l15.594-26.433a.84.84 0 00-.028-.898zm-38.923 7.15l31.86-4.858-24.817 10.666-7.043-5.808zm10.834 9.685a.847.847 0 00-.291.316l-2.948 5.537.14-8.197 21.124-9.079-18.025 11.423zm-2 7.103l2.71-5.089 2.479 2.045-5.189 3.044zm13.574 1.691l-9.693-7.993 23.013-14.586-13.32 22.58z",
  fill: "#444"
});

function SvgPaperplaneinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 335 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPaperplaneinline;